export default class HealthSituationUsage {
  type: string
  frequency: string

  constructor(type?: string, frequency?: string) {
    this.type = type ?? ''
    this.frequency = frequency ?? ''
  }

  isEmpty() {
    return !this.type || !this.frequency
  }

  reset() {
    this.type = ''
    this.frequency = ''
  }
}
